import { z } from 'zod';
import { ResourceLibraryArticleBaseItem } from '../types/resourceLibraryItems';
import { GetResourceLibraryArticleItemListingSchema } from '../schemas/resourceLibraryArticleItemZodSchemas';
import { hydrateResourceLibraryArticleBaseItem } from './transformResourceLibraryArticleItemResponse';

/**
 * Transforms and validates the response from the getResourceLibraryArticleItemListing GraphQL query
 * to a simplified ResourceLibraryArticleItem[] type.
 *
 * @param data The response data from the getResourceLibraryArticleItemListing query
 * @returns An array of valid ResourceLibraryItem objects
 */
export function transformResourceLibraryArticleItemsResponse(
    data: unknown // GetResourceLibraryArticleItemListingQuery - use unknown for jest tests be able to
    // pass invalid data
): ResourceLibraryArticleBaseItem[] {
    // Parse and validate the data using the Zod schema
    const parsedResult = GetResourceLibraryArticleItemListingSchema.safeParse(data);

    if (!parsedResult.success) {
        console.error(
            'Validation failed for getResourceLibraryItemListing:',
            parsedResult.error.errors
        );
        return [];
    }

    const resourceArticleItemListingEdges =
        parsedResult.data.getResourceLibraryArticleItemListing.edges;

    // Transform resource items to simplified ResourceLibraryItem type
    return resourceArticleItemListingEdges.map(({ node }) => {
        const item = node as z.infer<
            typeof GetResourceLibraryArticleItemListingSchema
        >['getResourceLibraryArticleItemListing']['edges'][number]['node'];

        return hydrateResourceLibraryArticleBaseItem(item);
    });
}
